import { render, staticRenderFns } from "./mg-alert.vue?vue&type=template&id=963a60a4&scoped=true&"
import script from "./mg-alert.vue?vue&type=script&lang=js&"
export * from "./mg-alert.vue?vue&type=script&lang=js&"
import style0 from "./mg-alert.vue?vue&type=style&index=0&id=963a60a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a60a4",
  null
  
)

export default component.exports